import { authHeader } from '../_helpers/auth-header.jsx';

export const userService = {
    login,
    logout,
    getAll
};

function login(username, password) {

    let urlOrigin = window.location.origin;
    let urlParts = new URL(urlOrigin);

    let urlAPI = `${urlParts.protocol}//${urlParts.hostname}/api/dsd`;

    if (urlParts.hostname == 'localhost'){
        urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
    }
    if ((urlParts.hostname.split(".").length) == 1){
        urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
    }

    if (urlParts.hostname.startsWith('192.168')){
        urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
    }


    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };



    return fetch(`${urlAPI}/users/authenticate`, requestOptions)

        .then(handleResponse)
        .then(user => {
            // login successful if there's a user in the response
            if (user) {
                // store user details and basic auth credentials in local storage 
                // to keep user logged in between page refreshes
                user.authdata = window.btoa(username + ':' + password);
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        })
        .catch(e => {
            let errorMessage = e?.message || String(e) || 'Login error';

            return Promise.reject(errorMessage);
        });


}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let urlOrigin = window.location.origin;
    let urlParts = new URL(urlOrigin);

    let urlAPI = `${urlParts.protocol}//${urlParts.hostname}/api/dsd`;

    if (urlParts.hostname == 'localhost'){
        urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
    }
    if (urlParts.hostname.startsWith('192.168')){
        urlAPI = `${urlParts.protocol}//${urlParts.hostname}:5050`;
    }

    return fetch(`${urlAPI}/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        
//        const location = useLocation();

        let data;
        try {
            data = text && JSON.parse(text);
        } catch (e) {
            // If parsing fails, treat the text as an error message
            if (!response.ok) {
                // Special handling for rate limit
                if (response.status === 429) {
                    return Promise.reject('Too many login attempts. Please wait a few minutes before trying again.');
                }
                return Promise.reject(text || response.statusText || `HTTP ${response.status}`);
            }
            data = text;
        }
        
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();

                window.location.reload(true);
            }
            
            // Special handling for rate limit
            if (response.status === 429) {
                return Promise.reject('Too many login attempts. Please wait a few minutes before trying again.');
            }

            const error = (data && data.message) || text || response.statusText || `HTTP ${response.status}`;
            return Promise.reject(error);
        }

        return data;
    });
}